import { render, staticRenderFns } from "./PostDetailInvited.vue?vue&type=template&id=6cb02be0&scoped=true"
import script from "./PostDetailInvited.vue?vue&type=script&lang=js"
export * from "./PostDetailInvited.vue?vue&type=script&lang=js"
import style0 from "./PostDetailInvited.vue?vue&type=style&index=0&id=6cb02be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb02be0",
  null
  
)

export default component.exports